import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PaymentService } from '../../../shared/services/payment.service';
import { LoadingService } from '../../../service/loading-service.service';
import { SnackbarService } from '../../../shared/snackbar/snackbar.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-payment-callback',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './payment-callback.component.html',
    styleUrl: './payment-callback.component.scss'
})
export class PaymentCallbackComponent implements OnInit {
    status: 'success' | 'cancel' | 'processing' | 'error' = 'processing';
    sessionId: string | null = null;
    errorMessage: string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private paymentService: PaymentService,
        private loadingService: LoadingService,
        private snackbarService: SnackbarService,
        private translate: TranslateService
    ) { }

    ngOnInit(): void {
        this.loadingService.showLoader();

        // Get session_id from query params
        this.route.queryParams.subscribe(params => {
            this.sessionId = params['session_id'] || null;
            console.log("session ID", this.sessionId);
            if (!this.sessionId) {
                this.status = 'error';
                this.errorMessage = 'No session ID provided';
                this.loadingService.hideLoader();
                return;
            }

            // Verify the payment session
            this.verifyPayment();
        });
    }

    verifyPayment(): void {
        if (!this.sessionId) {
            this.status = 'error';
            this.loadingService.hideLoader();
            return;
        }

        this.paymentService.verifyPaymentSession(this.sessionId).subscribe({
            next: (response: any) => {
                this.loadingService.hideLoader();

                if (response.success) {
                    this.status = 'success';
                    this.snackbarService.showSuccess('Payment verified successfully');

                    // Redirect to assignments page after 2 seconds
                    setTimeout(() => {
                        this.router.navigate(['/components/assignments']);
                    }, 2000);
                } else {
                    this.status = 'error';
                    this.errorMessage = response.message || 'Payment verification failed';
                }
            },
            error: (error: any) => {
                this.loadingService.hideLoader();
                this.status = 'error';
                this.errorMessage = error.error?.message || error.message || 'Failed to verify payment';
                console.error('Payment verification error:', error);
            }
        });
    }

    onCancel(): void {
        this.router.navigate(['/components/assignments']);
    }

    onRetry(): void {
        if (this.sessionId) {
            this.status = 'processing';
            this.loadingService.showLoader();
            this.verifyPayment();
        }
    }
}